export const initialPopinsState = {
  criteriaConfirmation: false,
  noProposalsFound: false,
};
export const popinsActions = {
  CLOSE_ALL_POPINS: 'CLOSE_ALL_POPINS',
  CRITERIA_CONFIRMATION_OPEN: 'CRITERIA_CONFIRMATION_OPEN',
  CRITERIA_CONFIRMATION_CLOSE: 'CRITERIA_CONFIRMATION_CLOSE',
  NO_PROPOSAL_OPEN: 'NO_PROPOSAL_OPEN',
  NO_PROPOSAL_CLOSE: 'NO_PROPOSAL_CLOSE',
};

export const popinsReducer = (popinsState, action) => {
  switch (action.type) {
    case popinsActions.CRITERIA_CONFIRMATION_OPEN:
      return { ...popinsState, criteriaConfirmation: true };
    case popinsActions.CRITERIA_CONFIRMATION_CLOSE:
      return { ...popinsState, criteriaConfirmation: false };
    case popinsActions.NO_PROPOSAL_OPEN:
      return { ...popinsState, noProposalsFound: true };
    case popinsActions.NO_PROPOSAL_CLOSE:
      return { ...popinsState, noProposalsFound: false };
    case popinsActions.CLOSE_ALL_POPINS:
    default:
      return initialPopinsState;
  }
};
